<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <h1>Create Account</h1>
            <template v-if="registrationLoading">loading...</template>
            <template v-else-if="!registrationCompleted">
              <form @submit.prevent="submit">
                <input
                  v-model="inputs.username"
                  type="text"
                  id="username"
                  placeholder="username"
                />
                <input
                  v-model="inputs.password1"
                  type="password"
                  id="password1"
                  placeholder="password"
                />
                <input
                  v-model="inputs.password2"
                  type="password"
                  id="password2"
                  placeholder="confirm password"
                />
                <input
                  v-model="inputs.email"
                  type="email"
                  id="email"
                  placeholder="email"
                />
              </form>
              <button @click="createAccount(inputs)">create account</button>
              <span class="error" v-show="registrationError"
                >An error occured while processing your request.</span
              >
              <div>
                Already have an account?
                <router-link to="/login">login</router-link>|
                <router-link to="/password_reset">reset password</router-link>
              </div>
            </template>
            <template v-else>
              <div>
                Registration complete. You should receive an email shortly with
                instructions on how to activate your account.
              </div>
              <div>
                <router-link to="/login">return to login page</router-link>
              </div>
            </template>

            <v-card class="elevation-12">
              <v-toolbar color="indigo" dark flat>
                <v-toolbar-title>Login to DeltaCert</v-toolbar-title>
                <v-spacer />
                <v-icon>mdi-diamond-stone</v-icon>
              </v-toolbar>
              <v-card-text>
                <v-form
                  @submit.prevent="login(inputs)"
                  ref="form"
                  v-model="valid"
                >
                  <v-text-field
                    v-model="inputs.username"
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    :rules="[v => !!v || 'Email is required']"
                    required
                  />

                  <v-text-field
                    v-model="inputs.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    :rules="[v => !!v || 'Password is required']"
                    required
                  />

                  <v-btn type="submit" v-show="false">Login</v-btn>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="indigo"
                  @click="login(inputs)"
                  :disabled="!valid"
                  :dark="valid"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-snackbar v-model="snackbar">
      Error in login details
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      inputs: {
        username: "",
        password1: "",
        password2: "",
        email: ""
      }
    };
  },
  computed: mapState("signup", [
    "registrationCompleted",
    "registrationError",
    "registrationLoading"
  ]),
  methods: mapActions("signup", ["createAccount", "clearRegistrationStatus"]),
  beforeRouteLeave(to, from, next) {
    this.clearRegistrationStatus();
    next();
  }
};
</script>

<style>
form input {
  display: block;
}

.error {
  color: crimson;
  font-size: 12px;
}
</style>
